export default __webpack_public_path__ + "static/media/camera.8a70e860.svg";